import type { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import styles from './ThinkingSpinner.module.css';

export type ThinkingSpinnerSize = 'small' | 'medium' | 'large';

const sizeInPixels: Record<ThinkingSpinnerSize, number> = {
  small: 12,
  medium: 14,
  large: 20,
};

export type ThinkingSpinnerProps = Omit<
  ComponentPropsWithoutRef<'svg'>,
  'children'
> & {
  size?: ThinkingSpinnerSize;
};

export const ThinkingSpinner = ({
  size = 'medium',
  className,
  ...rest
}: ThinkingSpinnerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
    width={sizeInPixels[size]}
    height={sizeInPixels[size]}
    aria-hidden="true"
    fill="none"
    className={classNames(styles.root, className)}
    {...rest}
  >
    <g className={styles.shape} style={{ animationDelay: '0ms' }}>
      <path
        d="M24 4.7619C24 4.34112 23.6589 4 23.2381 4H15.7619C15.3411 4 15 4.34112 15 4.7619V12.2381C15 12.6589 15.3411 13 15.7619 13H17.9048C21.2711 13 24 10.2711 24 6.90476V4.7619Z"
        fill="currentColor"
      />
    </g>
    <g className={styles.shape} style={{ animationDelay: '600ms' }}>
      <rect
        width="9"
        height="9"
        rx="0.761905"
        transform="matrix(-1 0 0 1 13 4)"
        fill="currentColor"
      />
    </g>
    <g className={styles.shape} style={{ animationDelay: '1200ms' }}>
      <rect
        width="9"
        height="9"
        rx="4.5"
        transform="matrix(-1 0 0 1 24 15)"
        fill="currentColor"
      />
    </g>
    <g className={styles.shape} style={{ animationDelay: '1800ms' }}>
      <path
        d="M13 19.5C13 17.0147 10.9853 15 8.5 15C6.01472 15 4 17.0147 4 19.5V23.4375C4 23.7482 4.25184 24 4.5625 24H8.5C10.9853 24 13 21.9853 13 19.5Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
